export const review = {
    writingPlaceholder: "학점, 로드 등의 평가에 대하여 설명해주세요.",
    like: "좋아요",
    notOpenYet: "수강 취소기간이 지난 후 후기 작성이 가능합니다",
}
